<span class="loadingInput start" [class]="showPageNumber() | responsiveCSSClass : 'hiddenTinyView'">
  <input
    type="number"
    id="pageNumber"
    class="toolbarField pageNumber"
    title="Page"
    value="1"
    size="4"
    min="1"
    data-l10n-id="pdfjs-page-input"
    autocomplete="off"
    [disabled]="disablePageNumber()"
  />
</span>
<span [class]="showPageLabel() | responsiveCSSClass : 'hiddenLargeView'" id="numPages" class="toolbarLabel"></span>
